"use strict";

window.$ = window.jQuery = require('jquery');
let jQueryBridget = require('jquery-bridget');
let masonry = require('masonry-layout');
jQueryBridget('masonry', masonry, window.$);
